module.exports = __webpack_public_path__ + "media/images/iconPaginateLast__accent--dark-7b3e7f50b5507f628ffb119ce0afebe5.png";